import { pkgName } from '../appConstants';

const getPkgSlice = state => state[pkgName];
export const getAddressId = state => getPkgSlice(state).selectedAddressId;
